export default "__VITE_ASSET__BGPcB91d__"